import { PROPERTY } from 'core/constants/report-type';

export const DEFAULT_ENTITY_TYPE = PROPERTY;

export const MAX_NUMBER_OF_TOP_SEARCH_RECENT_ITEMS = 3;
export const MAX_NUMBER_OF_TOP_SEARCH_ITEMS = 6;
